<div mat-dialog-title class="dialog-title">
  <eon-ui-icon fxLayout fxLayoutAlign="end" [mat-dialog-close]="{status: 'closed'}" class=closeX
               name="close"></eon-ui-icon>
  <div
    class="headline">{{(question ? 'Edit Question' : 'Add Question')}}</div>
</div>

<div mat-dialog-content fxFlex class="dialog-content">
  <div fxLayout="column" fxLayoutGap="12px" [formGroup]="formGroup!!">
    <div>
      <eon-ui-input [formControl]="questionStringInput!!" placeholder="Enter Question" label="Question"></eon-ui-input>
      <eon-ui-form-message type="error" message="field is required" [hidden]="!hasQuestionError()" scheme="white"></eon-ui-form-message>
    </div>

    <div>
      <eon-ui-input [formControl]="correctAnswerInput!!" placeholder="Correct Answer" label="Correct Answer"></eon-ui-input>
    </div>

  <div>
    <eon-ui-input [formControl]="answerOptionOneInput!!" placeholder="Answer Option 1" label="Answer Option 1"></eon-ui-input>
  </div>

    <div>
      <eon-ui-input [formControl]="answerOptionTwoInput!!" placeholder="Answer Option 2" label="Answer Option 2"></eon-ui-input>
    </div>

    <div>
      <eon-ui-input [formControl]="answerOptionThreeInput!" placeholder="Answer Option 3" label="Answer Option 3"></eon-ui-input>
    </div>
  </div>
</div>

<div mat-dialog-actions style="justify-content: space-between;">
  <eon-ui-button scheme="redInverted" icon="close" text="Cancel"
                 [mat-dialog-close]="{status: 'closed'}"></eon-ui-button>
  <eon-ui-button (click)="update()" icon="{{question ? 'save' : 'add'}}" ></eon-ui-button>
</div>
